// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"719c95b3","278":"75fc8866","414":"13b21590","577":"d2601e89","841":"ac56e6fd"}[chunkId] + ".chunk.js";
};